import { render } from "./SystemColorPickerView.vue?vue&type=template&id=6f71130b&scoped=true&ts=true"
import script from "./SystemColorPickerView.vue?vue&type=script&lang=ts"
export * from "./SystemColorPickerView.vue?vue&type=script&lang=ts"

import "./SystemColorPickerView.vue?vue&type=style&index=0&id=6f71130b&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f71130b"]])

export default __exports__